export default "__VITE_ASSET__qivaF6Pr__"